import type { PoseRef } from '@studio/shared';

import { api } from './api';
import { downscaleImage } from './downscale';

/**
 * A pose from its photograph alone: nothing to fill in, nothing read, and
 * not named after its file — a file's name is a camera's or a generator's,
 * not the pose's. The studio calls it "Pose N"; it can be renamed.
 */
export async function addPosePhoto(file: File): Promise<PoseRef> {
  const asset = await api.uploadAsset(await downscaleImage(file), 'reference');
  return api.createPose({ assetId: asset.id });
}
